import { useCallback } from 'react';
import { WorkBook, write } from 'xlsx';
import File from '../../Editor/utils/impl/File';

export const useUploadXlsx = () => useCallback(
	(onProgress: VoidFunction): Promise<string | ArrayBuffer> => new Promise((resolve, reject) => {
		const fileHandler = new File();
		fileHandler.getXLSXData((workbook: WorkBook) => {
			onProgress();
			if (workbook) {
				const arrayBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
				resolve(arrayBuffer);
			} else {
				reject(new Error('Ошибка загрузки XLSX файла'));
			}
		});
	}),
	[],
);
